export default __webpack_public_path__ + "static/media/dinosound-element.31614d7d.jpg";